import { render, staticRenderFns } from "./TotalCategory.vue?vue&type=template&id=a6f9a50c&scoped=true"
import script from "./TotalCategory.vue?vue&type=script&lang=js"
export * from "./TotalCategory.vue?vue&type=script&lang=js"
import style0 from "./TotalCategory.vue?vue&type=style&index=0&id=a6f9a50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f9a50c",
  null
  
)

export default component.exports